export function mensajeCertificadoDev(empresaActual, lastReporteDev?): string {
    const fechaActual = new Date();
    const formatoFecha = `${fechaActual.getDate()}/${fechaActual.getMonth() + 1}/${fechaActual.getFullYear()}`;
    const infoCertificado = {
        anio: lastReporteDev ? lastReporteDev.anio : empresaActual.anio,
        semestre: lastReporteDev
            ? lastReporteDev.semestre
            : empresaActual.semestre,
        razonSocial: empresaActual.razonSocial,
        nit: empresaActual.nit,
        fechaInicio: lastReporteDev ? lastReporteDev.fechaInicio : formatoFecha,
    };
    const semestre =
        Number(infoCertificado.semestre) === 1
            ? 'Enero a Junio'
            : Number(infoCertificado.semestre) === 2
              ? 'Julio a Diciembre'
              : 'Semestre no definido';
    const fechaValor = new Date(infoCertificado.fechaInicio);
    const formatoFechaCertificado = `${fechaValor.getDate()}/${fechaValor.getMonth() + 1}/${fechaValor.getFullYear()}`;

    const mensaje = `Se notifica que la novedad correspondiente al año ${infoCertificado.anio},
semestre ${semestre}, para la empresa ${infoCertificado.razonSocial} con NIT ${infoCertificado.nit}, 
ha sido registrado exitosamente el día ${formatoFechaCertificado}.

Gracias por su colaboración y por su confianza en nuestros servicios. 
Para gestionar cualquier inquietud adicional, contáctese al correo 
gestionsiriiagro@upra.gov.co.

Cordialmente,
`;

    const lineas = mensaje.split('\n');

    const mensajeJustificado = lineas
        .map((linea) => {
            const palabras = linea.trim().split(' ');
            const espacioEntrePalabras = Math.max(
                1,
                Math.floor(
                    (80 - palabras.join(' ').length) / (palabras.length - 1)
                )
            );

            const lineaJustificada = palabras.reduce(
                (resultado, palabra, index) => {
                    if (index === 0) return palabra;
                    return (
                        resultado + ' '.repeat(espacioEntrePalabras) + palabra
                    );
                },
                ''
            );
            return lineaJustificada;
        })
        .join('\n');

    return mensajeJustificado;
}
